/**
 * @file OrganizationContactPeopleToggle.tsx
 *
 * @fileoverview Sometimes we might want to show contact people only when a button is clicked.
 */

import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import {
  Maybe,
  OrganizationProfile,
  OrgProfileContactPerson,
} from '~/jobiqo/types/types';

interface OrganizationContactPeopleToggleProps {
  /**
   * The contact person to show.
   */
  contact: Maybe<OrgProfileContactPerson>;
  /**
   * The current organization.
   */
  organization?: Maybe<OrganizationProfile>;
  /**
   * The elements to show.
   */
  children: Slottable<React.ReactNode>;
}

export default function OrganizationContactPeopleToggle({
  children,
  contact,
  organization,
}: OrganizationContactPeopleToggleProps) {
  return children;
}
export { OrganizationContactPeopleToggle };
